import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import { makeStyles, Theme } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Link } from 'react-router-dom';

const useStyles = makeStyles<Theme>(theme => ({
  moreThemesTooltip: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    padding: theme.spacing(2),
    marginLeft: theme.spacing(1.5),
    boxShadow: theme.shadows[8],
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    maxWidth: 280,
    border: `1px solid ${theme.palette.divider}`,
  },
  tooltipIconContainer: {
    width: 40,
    height: 40,
    borderRadius: 10,
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  tooltipIcon: {
    fontSize: 20,
    color: theme.palette.primary.contrastText,
  },
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  tooltipTipLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    fontWeight: 500,
  },
  tooltipTipIcon: {
    fontSize: 14,
  },
  tooltipDescription: {
    color: theme.palette.text.primary,
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.4,
    margin: 0,
  },
  moreThemesLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    marginTop: theme.spacing(0.5),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  linkArrow: {
    fontSize: 16,
  },
}));

interface MoreThemesTooltipProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const MoreThemesTooltip = ({
  open,
  anchorEl,
  onMouseEnter,
  onMouseLeave,
}: MoreThemesTooltipProps) => {
  const classes = useStyles();

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="right"
      style={{ zIndex: 1400 }}
      modifiers={{
        flip: {
          enabled: true,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'viewport',
        },
      }}
    >
      <Paper
        className={classes.moreThemesTooltip}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className={classes.tooltipContent}>
          <span className={classes.tooltipTipLabel}>
            <InfoOutlinedIcon className={classes.tooltipTipIcon} />
            Tip
          </span>
          <p className={classes.tooltipDescription}>
            More themes available in settings
          </p>
          <Link to="/settings" className={classes.moreThemesLink}>
            Go to settings
            <ArrowForwardIcon className={classes.linkArrow} />
          </Link>
        </div>
      </Paper>
    </Popper>
  );
};
